import React from 'react';
//  Redux and Router

import { useDispatch } from 'react-redux';
// API
import { holdTemplateNames, setSingedFields } from '../../Store/Redux/FileListSlice';
// MUI
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
// Page
import { useQueryParameters } from './useQueryParameters';
import PrimaryButton from './Button/PrimaryButton';

const BackWarningDialog = ({ open, onClose, handleBackBtn = () => {} }) => {
  const dispatch = useDispatch();
  const { getParameter } = useQueryParameters();
  const createmode = getParameter('createmode');

  const handleConfirmBack = () => {
    if (createmode === 'true') {
      handleBackBtn();
    }
    dispatch(holdTemplateNames(''));
    dispatch(setSingedFields([]));
    onClose();
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          height: '200px',
          width: '312px',
          borderRadius: '8px'
        }
      }}
    >
      <DialogTitle>Warning</DialogTitle>
      <DialogContent sx={{ color: 'rgba(0, 0, 0, 0.87)' }}>
        Are you sure you want to go back? Any unsaved changes may be lost.
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center' }}>
        <PrimaryButton
          value='Cancel'
          onClick={onClose}
          textcolor='#B7D423'
          padding='10px 30px'
          backgroundColor='transparent'
          borderRadius='8px'
          border='2px solid #B7D423'
        />
        <PrimaryButton
          value='Continue'
          onClick={handleConfirmBack}
          color='primary'
          backgroundColor='#B7D423'
          padding='10px 30px'
          borderRadius='8px'
        />
      </DialogActions>
    </Dialog>
  );
};

export default BackWarningDialog;
